module.exports = __webpack_public_path__ + "img/13.2c08a979.jpg";